import React, { useRef } from 'react';

const ButtonBlock = ({ data, onChange }) => {
  const alignment = data.alignment || 'left';
  const uniqueIdRef = useRef(`button-${Math.random().toString(36).substr(2, 9)}`);
  const uniqueId = uniqueIdRef.current;

  return (
    <div className="basic-form">
      <div className="mb-3">
        <label className="form-label">Button Text</label>
        <input
          type="text"
          className="form-control"
          placeholder="Button text..."
          value={data.text || ''}
          onChange={(e) => onChange({ ...data, text: e.target.value })}
        />
      </div>
      
      <div className="mb-3">
        <label className="form-label">Button URL</label>
        <input
          type="url"
          className="form-control"
          placeholder="https://example.com"
          value={data.url || ''}
          onChange={(e) => onChange({ ...data, url: e.target.value })}
        />
      </div>

      <div className="mb-3">
        <label className="form-label">Alignment</label>
        <div className="btn-group w-100" role="group">
          <input
            type="radio"
            className="btn-check"
            name={`alignment-${uniqueId}`}
            id={`align-left-${uniqueId}`}
            checked={alignment === 'left'}
            onChange={() => onChange({ ...data, alignment: 'left' })}
          />
          <label className="btn btn-outline-primary" htmlFor={`align-left-${uniqueId}`}>
            <i className="bi bi-text-left me-1"></i> Left
          </label>

          <input
            type="radio"
            className="btn-check"
            name={`alignment-${uniqueId}`}
            id={`align-center-${uniqueId}`}
            checked={alignment === 'center'}
            onChange={() => onChange({ ...data, alignment: 'center' })}
          />
          <label className="btn btn-outline-primary" htmlFor={`align-center-${uniqueId}`}>
            <i className="bi bi-text-center me-1"></i> Center
          </label>

          <input
            type="radio"
            className="btn-check"
            name={`alignment-${uniqueId}`}
            id={`align-right-${uniqueId}`}
            checked={alignment === 'right'}
            onChange={() => onChange({ ...data, alignment: 'right' })}
          />
          <label className="btn btn-outline-primary" htmlFor={`align-right-${uniqueId}`}>
            <i className="bi bi-text-right me-1"></i> Right
          </label>
        </div>
      </div>
    </div>
  );
};

export default ButtonBlock;
